__turbopack_context__.v({
  "offerBanner": "OfferBanner-module__EgxXRq__offerBanner",
  "offerBannerTapTarget": "OfferBanner-module__EgxXRq__offerBannerTapTarget",
  "offerBtn": "OfferBanner-module__EgxXRq__offerBtn",
  "offerBtnDisabled": "OfferBanner-module__EgxXRq__offerBtnDisabled",
  "offerContent": "OfferBanner-module__EgxXRq__offerContent",
  "offerContentMobile": "OfferBanner-module__EgxXRq__offerContentMobile",
  "offerIcon": "OfferBanner-module__EgxXRq__offerIcon",
  "offerLeft": "OfferBanner-module__EgxXRq__offerLeft",
  "offerSlide": "OfferBanner-module__EgxXRq__offerSlide",
  "offerTrack": "OfferBanner-module__EgxXRq__offerTrack",
  "offerViewport": "OfferBanner-module__EgxXRq__offerViewport",
});
